import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

if (environment.production) {
  enableProdMode();
}

if (!environment.production) {
  window.addEventListener('unhandledrejection', (e) =>
    console.error('[KC-DEBUG] Unhandled rejection:', e.reason));
  window.addEventListener('error', (e) =>
    console.error('[KC-DEBUG] Global error:', e.error ?? e.message));
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => {
    console.error('[Bootstrap failed]', err);
    console.error('type:', typeof err);
    console.error('keys:', err && Object.keys(err));
    console.error('string:', String(err));
    try { console.error('json:', JSON.stringify(err)); } catch {}
  });
